'use client';

import { useId } from 'react';
import { Gradient } from '../gradient';

export const Security = () => {
  const gradientId = useId();

  return (
    <>
      <Gradient gradientId={gradientId} />
      <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.1"
          d="M119.552 244.244C118.149 271.849 117.428 299.483 117.391 327.146H142.028C142.028 299.468 141.303 271.834 139.853 244.244H119.552Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M105.811 118.554C105.823 118.527 105.811 119.196 105.811 119.865C105.811 120.535 105.823 120.535 105.823 121.204C105.823 121.873 105.823 122.542 105.823 123.212C105.823 123.881 105.823 124.55 105.811 125.219L105.823 127.227C105.823 127.896 105.823 128.566 105.823 129.235C105.823 129.904 105.823 130.573 105.823 131.243C105.823 133.251 105.823 135.315 105.823 137.266C105.823 139.217 105.823 141.281 105.824 142.62C105.824 143.289 105.823 143.289 105.797 143.958H291.511C291.713 143.959 291.907 143.754 292.052 143.386C292.198 143.018 292.285 142.516 292.294 141.984L292.753 118.553L105.811 118.554Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.3"
          d="M105.824 118.553C105.824 119.196 105.824 119.196 105.824 119.865C105.824 120.534 105.824 120.534 105.824 121.204C105.824 121.873 105.824 122.542 105.824 123.211C105.824 123.881 105.824 123.881 105.824 124.55V127.227C105.824 127.896 105.824 128.566 105.824 129.235C105.824 129.904 105.824 130.573 105.823 131.243C105.819 133.04 105.824 135.258 105.824 137.266C105.824 139.217 105.821 140.612 105.823 142.62C105.823 143.289 105.797 143.289 105.797 143.958H291.511C291.713 143.959 291.907 143.754 292.052 143.386C292.198 143.018 292.285 142.516 292.294 141.984L292.753 118.553H105.824Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M100.606 335.171H299.399C299.559 335.171 299.711 335.456 299.824 335.964C299.937 336.472 300 337.162 300 337.88V352.554H100V337.88C100 337.522 100.016 337.168 100.046 336.838C100.077 336.508 100.121 336.208 100.178 335.956C100.234 335.705 100.301 335.506 100.374 335.371C100.448 335.236 100.526 335.168 100.606 335.171Z"
          fill={`url(#${gradientId})`}
        />
        <path
          d="M277.456 156.374H261.028L252.793 148.146H285.421L277.456 156.374Z"
          fill={`url(#${gradientId})`}
        />
        <path
          d="M285.418 142.761H252.805V148.141H285.418V142.761Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.3"
          d="M277.456 156.374H261.028L252.793 148.146H285.421L277.456 156.374Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          opacity="0.5"
          d="M285.418 142.761H252.805V148.141H285.418V142.761Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M284.06 327.144C284.06 269.595 282.316 212.098 278.827 154.655H258.858C255.409 212.079 253.665 269.575 253.625 327.144H284.06Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.4"
          d="M284.06 327.144C284.06 269.595 282.316 212.098 278.827 154.655H258.858C255.409 212.079 253.665 269.575 253.625 327.144H284.06Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M278.548 156.046H259.659C259.384 156.046 259.12 155.945 258.925 155.766C258.73 155.586 258.621 155.342 258.621 155.088C258.621 154.833 258.73 154.588 258.924 154.406C259.119 154.224 259.383 154.121 259.659 154.117H278.548C278.827 154.117 279.095 154.22 279.292 154.402C279.489 154.584 279.6 154.831 279.6 155.088C279.596 155.344 279.484 155.587 279.287 155.766C279.09 155.946 278.824 156.046 278.548 156.046Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.4"
          d="M278.548 156.046H259.659C259.384 156.046 259.12 155.945 258.925 155.766C258.73 155.586 258.621 155.342 258.621 155.088C258.621 154.833 258.73 154.588 258.924 154.406C259.119 154.224 259.383 154.121 259.659 154.117H278.548C278.827 154.117 279.095 154.22 279.292 154.402C279.489 154.584 279.6 154.831 279.6 155.088C279.596 155.344 279.484 155.587 279.287 155.766C279.09 155.946 278.824 156.046 278.548 156.046Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M250.595 327.145H288.54C288.889 327.145 289.224 327.28 289.471 327.52C289.718 327.76 289.857 328.086 289.857 328.426V335.167H249.277V328.398C249.285 328.063 249.427 327.744 249.673 327.51C249.919 327.276 250.25 327.144 250.595 327.145Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.5"
          d="M250.595 327.145H288.54C288.889 327.145 289.224 327.28 289.471 327.52C289.718 327.76 289.857 328.086 289.857 328.426V335.167H249.277V328.398C249.285 328.063 249.427 327.744 249.673 327.51C249.919 327.276 250.25 327.144 250.595 327.145Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          opacity="0.5"
          d="M250.595 327.145H288.54C288.889 327.145 289.224 327.28 289.471 327.52C289.718 327.76 289.857 328.086 289.857 328.426V335.167H249.277V328.398C249.285 328.063 249.427 327.744 249.673 327.51C249.919 327.276 250.25 327.144 250.595 327.145Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M207.493 156.374H191.051L182.83 148.146H215.444L207.493 156.374Z"
          fill={`url(#${gradientId})`}
        />
        <path
          d="M215.444 142.761H182.83V148.141H215.444V142.761Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.3"
          d="M207.493 156.374H191.051L182.83 148.146H215.444L207.493 156.374Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          opacity="0.5"
          d="M215.444 142.761H182.83V148.141H215.444V142.761Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M214.491 327.144C214.491 269.595 212.751 212.098 209.271 154.655H189.277C185.837 212.079 184.097 269.575 184.057 327.144H214.491Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.4"
          d="M214.491 327.144C214.491 269.595 212.751 212.098 209.271 154.655H189.277C185.837 212.079 184.097 269.575 184.057 327.144H214.491Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M208.575 156.046H189.701C189.424 156.046 189.159 155.946 188.962 155.766C188.765 155.587 188.652 155.344 188.648 155.088C188.648 154.961 188.676 154.834 188.729 154.717C188.781 154.599 188.859 154.492 188.957 154.402C189.054 154.311 189.17 154.24 189.298 154.191C189.426 154.142 189.563 154.117 189.701 154.117H208.575C208.854 154.117 209.122 154.22 209.319 154.402C209.517 154.584 209.628 154.831 209.628 155.088C209.624 155.344 209.511 155.587 209.314 155.766C209.117 155.946 208.852 156.046 208.575 156.046Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.4"
          d="M208.575 156.046H189.701C189.424 156.046 189.159 155.946 188.962 155.766C188.765 155.587 188.652 155.344 188.648 155.088C188.648 154.961 188.676 154.834 188.729 154.717C188.781 154.599 188.859 154.492 188.957 154.402C189.054 154.311 189.17 154.24 189.298 154.191C189.426 154.142 189.563 154.117 189.701 154.117H208.575C208.854 154.117 209.122 154.22 209.319 154.402C209.517 154.584 209.628 154.831 209.628 155.088C209.624 155.344 209.511 155.587 209.314 155.766C209.117 155.946 208.852 156.046 208.575 156.046Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M180.981 327.145H217.567C217.905 327.145 218.228 327.28 218.467 327.52C218.705 327.76 218.839 328.086 218.839 328.426V335.167H179.709V328.398C179.716 328.063 179.853 327.744 180.091 327.51C180.329 327.276 180.648 327.144 180.981 327.145Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.5"
          d="M180.981 327.145H217.567C217.905 327.145 218.228 327.28 218.467 327.52C218.705 327.76 218.839 328.086 218.839 328.426V335.167H179.709V328.398C179.716 328.063 179.853 327.744 180.091 327.51C180.329 327.276 180.648 327.144 180.981 327.145Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M137.512 156.374H121.071L112.85 148.146H145.463L137.512 156.374Z"
          fill={`url(#${gradientId})`}
        />
        <path
          d="M145.463 142.761H112.85V148.141H145.463V142.761Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.3"
          d="M137.512 156.374H121.071L112.85 148.146H145.463L137.512 156.374Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          opacity="0.5"
          d="M145.463 142.761H112.85V148.141H145.463V142.761Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M144.927 327.144C144.927 269.595 143.096 212.098 139.434 154.655H118.536C114.906 212.079 113.075 269.575 113.043 327.144H144.927Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.4"
          d="M144.927 327.144C144.927 269.595 143.096 212.098 139.434 154.655H118.536C114.906 212.079 113.075 269.575 113.043 327.144H144.927Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M138.61 156.046H119.779C119.502 156.046 119.237 155.946 119.04 155.766C118.843 155.587 118.73 155.344 118.727 155.088C118.727 154.831 118.837 154.584 119.035 154.402C119.232 154.22 119.5 154.117 119.779 154.117H138.667C138.944 154.121 139.208 154.224 139.402 154.406C139.597 154.588 139.706 154.833 139.706 155.088C139.706 155.219 139.677 155.348 139.622 155.467C139.566 155.587 139.484 155.695 139.382 155.785C139.279 155.875 139.158 155.944 139.025 155.989C138.893 156.034 138.752 156.053 138.61 156.046Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.4"
          d="M138.61 156.046H119.779C119.502 156.046 119.237 155.946 119.04 155.766C118.843 155.587 118.73 155.344 118.727 155.088C118.727 154.831 118.837 154.584 119.035 154.402C119.232 154.22 119.5 154.117 119.779 154.117H138.667C138.944 154.121 139.208 154.224 139.402 154.406C139.597 154.588 139.706 154.833 139.706 155.088C139.706 155.219 139.677 155.348 139.622 155.467C139.566 155.587 139.484 155.695 139.382 155.785C139.279 155.875 139.158 155.944 139.025 155.989C138.893 156.034 138.752 156.053 138.61 156.046Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M111.417 327.145H148.007C148.173 327.145 148.339 327.178 148.493 327.242C148.647 327.306 148.787 327.401 148.905 327.52C149.023 327.639 149.116 327.78 149.18 327.936C149.244 328.091 149.277 328.258 149.277 328.426V335.167H110.146V328.398C110.154 328.063 110.291 327.744 110.528 327.51C110.766 327.276 111.085 327.144 111.417 327.145Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.5"
          d="M111.417 327.145H148.007C148.173 327.145 148.339 327.178 148.493 327.242C148.647 327.306 148.787 327.401 148.905 327.52C149.023 327.639 149.116 327.78 149.18 327.936C149.244 328.091 149.277 328.258 149.277 328.426V335.167H110.146V328.398C110.154 328.063 110.291 327.744 110.528 327.51C110.766 327.276 111.085 327.144 111.417 327.145Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M105.797 117.217C106.112 117.496 106.352 117.976 106.466 118.554H292.753V117.217H105.797Z"
          fill={`url(#${gradientId})`}
        />
        <path
          opacity="0.5"
          d="M105.797 117.217C105.797 117.217 105.797 117.885 105.797 118.554H292.753V117.217H105.797Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M198.551 41L104.348 113.205H292.753L198.551 41Z"
          fill={`url(#${gradientId})`}
        />
      </svg>
    </>
  );
};
